export default __webpack_public_path__ + "static/media/Iconly-Light-Delete.08234229.svg";